<script lang="ts" setup>
import { defineProps, defineModel } from "vue";

const isActive = defineModel({ default: false });

defineProps({
  readOnly: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <label
    class="switcher-container"
    :class="{ '--active': isActive, '--read-only': readOnly }"
  >
    <input v-model="isActive" :disabled="readOnly" type="checkbox" />
    <div class="switcher-container__bounce"></div>
  </label>
</template>

<style lang="scss" scoped>
.switcher-container {
  $bounce-width: 20px !default;
  $bounce-offset: 2px;
  border-radius: 30px;
  background: #eaeaea;
  width: 48px;
  height: 24px;
  display: flex;
  align-items: center;
  padding: 1px;
  cursor: pointer;
  transition: background-color 0.4s;
  position: relative;
  input {
    display: none;
  }
  input:checked ~ .switcher-container__bounce {
    left: calc(100% - #{$bounce-width} - #{$bounce-offset});
    background-color: var(--color-secondary);
  }
  input:disabled ~ .switcher-container__bounce {
    opacity: 0.9;
    cursor: default;
  }

  &__bounce {
    position: absolute;
    top: 0;
    bottom: 0;
    left: $bounce-offset;
    margin: auto 0;
    width: $bounce-width;
    height: $bounce-width;
    background-color: #6568731a;
    border-radius: 50%;
    transition: all 0.15s ease-in-out;
  }
  &.--active {
    background-color: #d9d7e3;
  }
  &.--read-only {
    pointer-events: none;
  }
}
</style>
